import { z } from "zod";

import { RoleSchema } from "api/schemas/shared";

const GetTreatmentAdherenceArgsSchema = z.object({
  patient_id: z.number(),
  role: RoleSchema,
  treatment_id: z.number(),
  params: z.object({
    end_time: z.string(),
    start_time: z.string(),
  }),
});
export type GetTreatmentAdherenceArgs = z.infer<typeof GetTreatmentAdherenceArgsSchema>;

const AdherenceSchema = z.object({ adherence: z.number(), completed: z.number(), total: z.number() });

export const TreatmentAdherenceSchema = z.object({
  adherence: z.record(z.string(), AdherenceSchema),
});
export type TreatmentAdherence = z.infer<typeof TreatmentAdherenceSchema>;
